import { useMemo } from 'react'

import { useGlobalConfig } from './use-global-config'

export const useInstanceName = () => {
  const { mailerDns } = useGlobalConfig()

  return useMemo(() => (mailerDns ? mailerDns.split('.')[0] : ''), [mailerDns])
}
